module.exports = __webpack_public_path__ + "static/media/ibd_foot2.a65b4383.png";